export function pluralize(n, singular, plural) {
  if (n == 1) {
    return singular.replace("{{n}}", n)
  } else {
    return plural.replace("{{n}}", n)
  }
}

// Series colors for reactor `-html` field descriptions (same as charts/primary metrics).
// astral = metric (ms, %, jobs, …); azure = dyno quantity.
export function metric(value) {
  return `<strong class="font-semibold text-astral-700 dark:text-astral-300">${value}</strong>`
}

export function dynos(value) {
  return `<strong class="font-semibold text-azure-700 dark:text-azure-300">${value}</strong>`
}

// Humanizes a minute count into "1 day, 2 hours, and 30 minutes" style prose.
export function formatDelay(minutes) {
  const days  = Math.floor(minutes / 1440)
  const hours = Math.floor((minutes % 1440) / 60)
  const mins  = minutes % 60

  const parts = []
  if (days > 0) parts.push(`${days} ${days === 1 ? "day" : "days"}`)
  if (hours > 0) parts.push(`${hours} ${hours === 1 ? "hour" : "hours"}`)
  if (mins > 0) parts.push(`${mins} ${mins === 1 ? "minute" : "minutes"}`)

  if (parts.length === 1) return parts[0]
  if (parts.length === 2) return `${parts[0]} and ${parts[1]}`
  return `${parts.slice(0, -1).join(", ")}, and ${parts[parts.length - 1]}`
}

// "Oct 08, 17:57" in local time, with the seconds on request.
export function formatMonthDayTime(date, { seconds = false } = {}) {
  const pad = (n) => String(n).padStart(2, "0")
  const month = date.toLocaleString(undefined, { month: "short" })
  const time = [date.getHours(), date.getMinutes(), ...(seconds ? [date.getSeconds()] : [])].map(pad).join(":")
  return `${month} ${pad(date.getDate())}, ${time}`
}

export function setClass(element, ...classes) {
  element.setAttribute("class", classes.flat().join(" "))
}

export async function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

// Matches the .switch-knob transition in components.css.
export const SWITCH_SLIDE_MS = 200

// The lg breakpoint: the sidebar docks and the phone bottom bar goes away.
export const DESKTOP = "(min-width: 1024px)"

export function isDesktop() {
  return window.matchMedia(DESKTOP).matches
}

function bottomBar() {
  const bar = document.getElementById("mobile-bottom-bar")
  return bar?.getClientRects().length ? bar : null
}

// Null when the bar is not on screen.
export function bottomBarTop() {
  return bottomBar()?.getBoundingClientRect().top ?? null
}

export function bottomBarHeight() {
  return bottomBar()?.offsetHeight ?? 0
}

export function isDarkMode() {
  return document.documentElement.classList.contains("dark")
}

export function csrfToken() {
  return document.querySelector("meta[name=csrf-token]").content
}

export function suppressProgressBar() {
  const Turbo = window.Turbo
  const delay = Turbo.config.drive.progressBarDelay
  Turbo.config.drive.progressBarDelay = 5000
  setTimeout(() => Turbo.config.drive.progressBarDelay = delay, 0)
}

// Same-URL Turbo morph refresh (periodic coordinator, form--refresh-on-submit, countdown).
export function turboRefresh() {
  document.body.insertAdjacentHTML("beforeend", '<turbo-stream action="refresh"></turbo-stream>')
}
